import InfoTip from "../../../components/InfoTip";
import {
  findRanking,
  formatAveragePackmatRate,
} from "../utils/collectionChartUtils";

const RANKING_ARROW = {
  up: "fa-arrow-up",
  down: "fa-arrow-down",
  stable: "fa-arrow-right",
};

const CollectionTrendSection = ({
  trendByWasteCategoryCurrent,
  trendByWasteCategoryPrevious,
  t,
  className = "",
}) => {
  return (
    <article
      className={["statistics-card collection-trend", className]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="dashboard-chart-heading">
        <h5 className="dashboard-chart-title">
          {t("rotationByFlux.summaryTitle")}
        </h5>
        <p className="dashboard-chart-subtitle">
          {t("rotationByFlux.subtitle")}
        </p>
      </div>

      <div className="collection-trend-table">
        <div className="collection-trend-row collection-trend-row--head">
          <span className="collection-trend-cell">{t("Flux")}</span>
          <span className="collection-trend-cell">{t("Rotations")}</span>
          <span className="collection-trend-cell collection-trend-cell--right">
            {t("Avg packmats per rotation")}
          </span>
          <span className="collection-trend-cell collection-trend-cell--right">
            {t("Avg filling rate")}
          </span>
        </div>

        {trendByWasteCategoryCurrent.map((item, index) => {
          const ranking = findRanking(
            item.wasteCategory,
            item.rotations,
            trendByWasteCategoryPrevious,
          );
          return (
            <div key={index} className="collection-trend-row">
              <span className="collection-trend-cell">
                {item.wasteCategory}
              </span>

              <div className="collection-trend-rotations">
                <i
                  className={`fas ${RANKING_ARROW[ranking]} collection-trend-rank collection-trend-rank--${ranking}`}
                  aria-hidden="true"
                />
                <span className="collection-trend-rotations-value">
                  {item.rotations}
                </span>
                <InfoTip widthMaxRem={18}>
                  {t("rotation_comparison", {
                    rotations:
                      trendByWasteCategoryPrevious.find(
                        (waste) => waste.wasteCategory === item.wasteCategory,
                      )?.rotations ?? 0,
                  })}
                </InfoTip>
              </div>

              <span className="collection-trend-cell collection-trend-cell--right">
                {formatAveragePackmatRate(item.averagePackmatRate)}
              </span>
              <span className="collection-trend-cell collection-trend-cell--right">
                {formatAveragePackmatRate(item.averageFillRate)}%
              </span>
            </div>
          );
        })}
      </div>
    </article>
  );
};

export default CollectionTrendSection;
